import { type EventTypeHost } from '../../../../../models/Scheduling'

export type HostPerson = Pick<EventTypeHost, 'userId' | 'name' | 'email' | 'status' | 'eligible' | 'calendar'> & { roleIds?: string[] }

export const hostDisplayName = (host: Pick<HostPerson, 'userId' | 'name' | 'email'>): string => host.name ?? host.email ?? host.userId
